module.exports = __webpack_public_path__ + "static/media/254856HD_v2_ATGAM_MedEd.9e8351e2.mp4";